import { render, staticRenderFns } from "./RoundCounterDashboard.vue?vue&type=template&id=e2f2008a"
import script from "./RoundCounterDashboard.vue?vue&type=script&lang=js"
export * from "./RoundCounterDashboard.vue?vue&type=script&lang=js"
import style0 from "./RoundCounterDashboard.vue?vue&type=style&index=0&id=e2f2008a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports